const INCORRECT_DATE = 'Некорректная дата';

export const VALIDATION_MESSAGES = {
  Email: {
    messageRequired: 'Укажите e-mail',
    messageFormat: 'E-mail указан не верно'
  },
  Phone: {
    messageRequired: 'Укажите номер телефона',
    messageFormat: 'Номер телефона указан не верно'
  },
  Snils: {
    messageRequired: 'Укажите СНИЛС',
    messageFormat: 'СНИЛС указан не верно'
  },
  ActRecordNumber: {
    messageRequired: 'Номер актовой записи',
    messageFormat: 'Неверный формат номера актовой записи'
  },
  ActRecordDate: {
    messageRequired: 'Дата составления актовой записи',
    messageFormat: INCORRECT_DATE,
    messageSpecial:
      'Дата составления актовой записи не может быть раньше даты рождения'
  },
  ActRecordRegPlace: {
    messageRequired:
      'Начните вводить название органа ЗАГС актовой записи и выберите из списка верный'
  },
  DocumentNumber: {
    messageRequired: 'Укажите серию и номер документа',
    messageFormat: 'Неверный формат'
  },
  DocumentIssuer: {
    messageRequired: 'Укажите подразделение выдачи',
    messageLength: 'Разрешено ввести не более 250 знаков'
  },
  DocumentDate: {
    messageRequired: 'Дата выдачи',
    messageFormat: INCORRECT_DATE
  },
  Birthdate: {
    messageRequired: 'Дата рождения',
    messageFormat: INCORRECT_DATE
  }
};
